var EmployeeRole = /* @__PURE__ */ ((EmployeeRole2) => {
  EmployeeRole2["NONE"] = "NONE";
  EmployeeRole2["ASSISTANT"] = "ASSISTANT";
  EmployeeRole2["ACCOUNTANT"] = "ACCOUNTANT";
  EmployeeRole2["HYGIENIST"] = "HYGIENIST";
  EmployeeRole2["DENTIST"] = "DENTIST";
  EmployeeRole2["DOCTOR"] = "DOCTOR";
  EmployeeRole2["CLINIC_MANAGER"] = "CLINIC_MANAGER";
  EmployeeRole2["RECEPTIONIST"] = "RECEPTIONIST";
  EmployeeRole2["DENTAL_TECHNICIAN"] = "DENTAL_TECHNICIAN";
  EmployeeRole2["TREATER"] = "TREATER";
  EmployeeRole2["NOT_SET"] = "NOT_SET";
  EmployeeRole2["NOT_MAPPED"] = "NOT_MAPPED";
  return EmployeeRole2;
})(EmployeeRole || {});
var EmployeeLevel = /* @__PURE__ */ ((EmployeeLevel2) => {
  EmployeeLevel2["CHIEF"] = "CHIEF";
  EmployeeLevel2["SENIOR"] = "SENIOR";
  EmployeeLevel2["JUNIOR"] = "JUNIOR";
  EmployeeLevel2["GRADUATE"] = "GRADUATE";
  return EmployeeLevel2;
})(EmployeeLevel || {});
var EmployeeStatus = /* @__PURE__ */ ((EmployeeStatus2) => {
  EmployeeStatus2["DISABLED"] = "DISABLED";
  EmployeeStatus2["INACTIVE"] = "INACTIVE";
  EmployeeStatus2["WILL_BE_ACTIVE"] = "WILL_BE_ACTIVE";
  EmployeeStatus2["ACTIVE"] = "ACTIVE";
  EmployeeStatus2["USED_TO_BE_ACTIVE"] = "USED_TO_BE_ACTIVE";
  EmployeeStatus2["UNKNOWN"] = "UNKNOWN";
  return EmployeeStatus2;
})(EmployeeStatus || {});
var EmployeeGender = /* @__PURE__ */ ((EmployeeGender2) => {
  EmployeeGender2["MALE"] = "MALE";
  EmployeeGender2["FEMALE"] = "FEMALE";
  EmployeeGender2["DIVERSE"] = "DIVERSE";
  return EmployeeGender2;
})(EmployeeGender || {});
var PractitionerType = /* @__PURE__ */ ((PractitionerType2) => {
  PractitionerType2["DOCTOR"] = "DOCTOR";
  PractitionerType2["EXPERT"] = "EXPERT";
  PractitionerType2["ASSISTANT"] = "ASSISTANT";
  PractitionerType2["NOT_MAPPED"] = "NOT_MAPPED";
  PractitionerType2["NOT_SET"] = "NOT_SET";
  PractitionerType2["GP"] = "GP";
  PractitionerType2["GYN"] = "GYN";
  PractitionerType2["CEO"] = "CEO";
  PractitionerType2["ORT"] = "ORT";
  PractitionerType2["FER"] = "FER";
  PractitionerType2["PLA"] = "PLA";
  PractitionerType2["INT"] = "INT";
  PractitionerType2["PED"] = "PED";
  PractitionerType2["SUR"] = "SUR";
  PractitionerType2["RAD"] = "RAD";
  PractitionerType2["ANE"] = "ANE";
  PractitionerType2["NUC"] = "NUC";
  PractitionerType2["COO"] = "COO";
  return PractitionerType2;
})(PractitionerType || {});
const LEVEL_ORDER = [
  "CHIEF",
  "SENIOR",
  "JUNIOR",
  "GRADUATE",
  null
];
const ROLE_ORDER = [
  "DENTIST",
  "HYGIENIST",
  "ASSISTANT",
  "RECEPTIONIST",
  "DENTAL_TECHNICIAN",
  "CLINIC_MANAGER",
  "ACCOUNTANT",
  void 0
];
export {
  EmployeeGender,
  EmployeeLevel,
  EmployeeRole,
  EmployeeStatus,
  LEVEL_ORDER,
  PractitionerType,
  ROLE_ORDER
};
